module.exports = __webpack_public_path__ + "static/media/real-time-flat.845a74dc.png";